import { render, staticRenderFns } from "./MenuVirtuales.vue?vue&type=template&id=49a9a6e1&scoped=true&"
import script from "./MenuVirtuales.vue?vue&type=script&lang=js&"
export * from "./MenuVirtuales.vue?vue&type=script&lang=js&"
import style0 from "./MenuVirtuales.vue?vue&type=style&index=0&id=49a9a6e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a9a6e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VIcon,VSheet,VSlideGroup,VSlideItem})
